// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3363":"c259c55259cd651f","4972":"c8a8bd69a44f7740","9006":"a5bc15eec45b7dfe"}[chunkId] + ".css";
};